import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { selectSelectedLanguage, selectSupportedLanguages } from 'src/app/dashboard/state/study/study.selectors';
import { Language } from 'src/app/models/language';
import { AppState } from 'src/app/state';

@Component({
  selector: 'dashboard-informative-pages',
  templateUrl: './informative-pages.component.html',
  styleUrls: ['./informative-pages.component.scss'],
})
export class InformativePagesComponent implements OnInit, OnDestroy {
  supportedLanguages$: Observable<Language[]>;
  supportedLanguages: Language[];
  selectedLanguage$: Observable<Language>;
  selectedLanguage: Language;

  private subscriptions$ = new Subscription();

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.supportedLanguages$ = this.store.select(selectSupportedLanguages);
    this.subscriptions$.add(this.supportedLanguages$.subscribe((languages) => (this.supportedLanguages = languages)));

    this.selectedLanguage$ = this.store.select(selectSelectedLanguage);
    this.subscriptions$.add(this.selectedLanguage$.subscribe((language) => (this.selectedLanguage = language)));
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
